module.exports = __webpack_public_path__ + "arrow-to-next.svg?eb6a582d3385be84af291f943b46d128";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-to-next.svg
// module id = 33
// module chunks = 0